function toQueryString(args) {
    return Object.entries(args)
        .filter(([, value]) => value !== undefined)
        .map(
            ([name, value]) =>
                `${encodeURIComponent(name)}=${encodeURIComponent(value)}`
        )
        .join('&');
}

export class RemoteError extends Error {
    constructor(message, props) {
        super(message);
        Object.assign(this, props);
    }
}

function tryParseJson(text) {
    try {
        return JSON.parse(text);
    } catch (e) {
        return undefined;
    }
}

async function createRemoteError(response, message) {
    const { status, statusText, url } = response;

    const text = await response.text();
    const json = tryParseJson(text);

    if (json && json.redirect) {
        window.location.href = json.redirect;
    } else {
        return new RemoteError(`${status} ${statusText} (${message})`, {
            status,
            text,
            json,
            url,
        });
    }
}

export default class ApiEndpoint {
    queryParams = {
        returnformat: 'json',
    };

    fetchOptions = {
        credentials: 'include',
    };

    constructor(endpoint) {
        this.endpoint = endpoint;
    }

    async callComponent(method, { query, ...fetchOptions }) {
        const params = { ...this.queryParams, ...query };
        const url = `${this.endpoint}/${method}?${toQueryString(params)}`;

        const response = await fetch(url, {
            ...this.fetchOptions,
            ...(fetchOptions || {}),
        });

        if (response.ok) {
            const text = await response.text();
            return text === '' ? undefined : JSON.parse(text);
        } else {
            const error = await createRemoteError(
                response,
                `${this.endpoint}@${method}`
            );
            throw error;
        }
    }

    get(method, args) {
        return this.callComponent(method, { query: args });
    }

    post(method, args) {
        return this.callComponent(method, {
            method: 'POST',
            body: JSON.stringify(args),
            headers: {
                'content-type': 'application/json',
            },
        });
    }

    async postForm(method, file) {
        const formData = new FormData();
        formData.append('file', file);
        const response = await fetch(`${this.endpoint}/${method}`, {
            method: 'POST',
            body: formData,
        });

        if (response.ok) {
            const text = await response.text();
            return text === '' ? undefined : JSON.parse(text);
        } else {
            const error = await createRemoteError(
                response,
                `${this.endpoint}@${method}`
            );
            throw error;
        }
    }
}
